<template>
  <div class="tabs">
    <div class="tabs__header">
      <div class="tabs__tab" v-for="(item, i) in tabArr" :key="i"
        @click="onClickTab(i)"
        :class="{'is-active': item.active}"
      >
        <slot :name="'tab_' + i">{{item.text}}</slot>
      </div>
    </div>
    <div class="tabs__content">
      <transition name="fade">
        <div class="tabs__panel"
          v-show="tabArr[0].active"
          :key="0"
        >
          <slot :name="'panel_0'" :active="tabArr[0].active"></slot>
        </div>
      </transition>

      <transition name="fade">
        <div class="tabs__panel"
          v-if="tabArr[1].active"
          :key="1"
        >
          <slot :name="'panel_1'" :active="tabArr[1].active"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabArr: [
        {active: true, text: '属性'},
        {active: false, text: '动画'}
      ]
    }
  },
  methods: {
    onClickTab (index) {
      this.tabArr.forEach((item, i) => {
        if (i === index) {
          item.active = true;
        } else {
          item.active = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/colors";
@import "../../../style/transition";

.tabs {
  &__header {
    text-align: center;
    font-size: 0;
    white-space: nowrap;
  }
  &__tab {
    display: inline-block;
    width: 116px;
    height: 32px;
    padding-bottom: 10px;
    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-bottom-color: $c1;
    // line-height: 32px;
    // border-radius: 4px;
    // background-color: #f4f6fd;
    font-size: 14px;
    cursor: pointer;
    transition-duration: 0.4s;

    // &:nth-child(1) {
    //   border-radius: 4px 0 0 4px;
    // }
    // &:last-child {
    //   border-radius: 0 4px 4px 0;
    // }

    &.is-active {
      // background-color: #d8dee9;
      color: $c2;
      border-bottom-color: $c2;
    }
  }

  &__content {
    position: relative;
    min-height: 480px;
  }

  &__panel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/popups/content/tabs.vue